<div class="scheduleTable">
    <div class="setTable" *ngIf="type == 'p'">
        <div class="actionSetTab">
            <!-- this is currect chip for size type -->
            <!-- <div style="display: flex; gap: 5px; cursor: pointer">
                <mat-chip class="sleek-chip" [class.primary-chip]="pickup==pickupfilter"
                    *ngFor="let pickup of containerSizesPickup" (click)="applyPickupTableFilter(pickup)">{{ pickup
                    }}</mat-chip>
            </div> -->
            <!-- this is the button toggle as the replacement -->
            <mat-button-toggle-group [ngModel]="pickupfilter" (ngModelChange)="applyPickupTableFilter($event)">
                <mat-button-toggle [value]="pickup " *ngFor="let pickup of containerSizesPickup">{{ pickup
                    }}</mat-button-toggle>
            </mat-button-toggle-group>

            <button class="addBtn clickIt sleekBtn" *ngIf="!isCustomer" mat-raised-button
                (click)="addNewPickupSchedule()">
                <span>Add Pick-up Schedule</span>
            </button>
        </div>
        <mat-table #pickupTable [dataSource]="pickupDataSource" matSort
            style="max-height: 500px; overflow: auto; margin-top: 10px;">
            <ng-container matColumnDef="display">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Size Type</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <mat-chip class="primary-chip sleek-chip">{{ isObject(data?.requirement?.container_size_type) ?
                        data?.requirement?.container_size_type.display + ' (' +
                        data?.requirement?.condition?.value + ')' : data?.requirement }}</mat-chip>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'display_name'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>On-Hire Location</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <span class="displayName">
                        {{ isObject(data?.port) ? data?.port.display_name : data?.port }}
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'per_month_permitted_quantity'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>PMQ</mat-header-cell>
                <mat-cell *matCellDef="let data; let i = index" class="fs-12">
                    <app-number-field [isEditable]="data.isPEdit" class="w-100i" [class.editable]="data.isPEdit"
                        [required]="false" [(ngModel)]="data.per_month_permitted_quantity"
                        [(errors)]="data.error.per_month_permitted_quantity" [minValue]="0" [noDecimal]="true">
                    </app-number-field>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'total_permitted_quantity'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>TPQ</mat-header-cell>
                <mat-cell *matCellDef="let data; let i = index" class="fs-12">
                    <app-number-field [isEditable]="data.isPEdit" class="w-100i" [class.editable]="data.isPEdit"
                        [ngStyle]="{'color': data.error.total_permitted_quantity.length != 0 ? 'red' : ''}"
                        [required]="false" [(ngModel)]="data.total_permitted_quantity"
                        [matTooltip]="data.error.total_permitted_quantity" [matTooltipClass]="'tooltip-error'"
                        [(errors)]="data.error.total_permitted_quantity" [minValue]="0" [noDecimal]="true">
                    </app-number-field>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'handling_charge'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Handling-Out Charges</mat-header-cell>
                <mat-cell *matCellDef="let data; let i = index" class="fs-12">
                    <app-number-field [isEditable]="data.isPEdit" class="w-100i" [class.editable]="data.isPEdit"
                        [required]="false" [numVal]="data.handling_charge_currency" [(ngModel)]="data.handling_charge"
                        [(errors)]="data.error.handling_charge" [minValue]="0">
                    </app-number-field>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'pickup_charge'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Pick-up Charges</mat-header-cell>
                <mat-cell *matCellDef="let data; let i = index" class="fs-12">
                    <app-number-field [isEditable]="data.isPEdit" class="w-100i" [class.editable]="data.isPEdit"
                        [required]="false" [numVal]="data.pickup_charge_currency" [(ngModel)]="data.pickup_charge"
                        [(errors)]="data.error.pickup_charge" [minValue]="0">
                    </app-number-field>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'remarks'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Remarks</mat-header-cell>
                <mat-cell *matCellDef="let data; let i = index" class="fs-12">
                    <app-text-field [isMultiline]="data.isPEdit" class="w-100i" [class.editable]="data.isPEdit"
                        [isEditable]="data.isPEdit" fxLayout="column" [(ngModel)]="data.remarks">
                    </app-text-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                <mat-cell *matCellDef="let data;let i = index">
                    <div class="actionButtons">

                        <!-- <button mat-icon-button class="save-button" > -->
                        <!-- <mat-icon>check_circle</mat-icon> -->
                        <i class="flaticon-tick" matTooltip="Save Changes" matTooltipPosition="left"
                            *ngIf="data.isPEdit" color="primary" (click)="savePickupEdit(data)"></i>
                        <!-- </button> -->
                        <!-- <button mat-icon-button class="save-button" > -->
                        <!-- <mat-icon>edit</mat-icon> -->
                        <i class="flaticon-pencil" *ngIf="!data.isPEdit" matTooltip="Edit" matTooltipPosition="left"
                            (click)="editPickup(data)"></i>
                        <!-- </button> -->
                        <!-- <button mat-icon-button class="delete-button" > -->
                        <i class="flaticon-delete delete" matTooltip="Delete" matTooltipPosition="right" color="warn"
                            (click)="deletePickup(i)"></i>
                        <!-- </button> -->
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row class="header-row" *matHeaderRowDef="pickupDisplayColumns sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: pickupDisplayColumns; let index"
                [style.background-color]="row.has_errors ? '#ff000047' : 'white'"
                [style.color]="row.has_errors ? 'white' : 'black'" [class.blur]="loading"
                [hidden]="row.hideRow == null ? false : row.hideRow != row.requirement?.container_size_type?.display">
            </mat-row>
        </mat-table>
        <div class="loadingData" [class.d-none]="!loading">
            <logzy-gear-loader></logzy-gear-loader>
        </div>
    </div>
    <div class="setTable" *ngIf="type == 'd'">
        <div class="actionSetTab">
            <!-- this is currect chip for size type -->
            <!-- <div style="display: flex; gap: 5px; cursor: pointer">
                <mat-chip class="sleek-chip" [class.primary-chip]="dropoff==dropofffilter" *ngFor="let dropoff of containerSizesDropoff"
                    (click)="applyDropoffTableFilter(dropoff)">{{ dropoff }}</mat-chip>
            </div> -->
            <!-- this is the button toggle as the replacement -->
            <mat-button-toggle-group [ngModel]="dropofffilter" (ngModelChange)="applyDropoffTableFilter($event)">
                <mat-button-toggle [value]="dropoff " *ngFor="let dropoff of containerSizesDropoff">{{ dropoff
                    }}</mat-button-toggle>
            </mat-button-toggle-group>
            <button class=" addBtn clickIt sleekBtn" *ngIf="!isCustomer" mat-raised-button
                (click)="addNewDropoffSchedule()">
                <span>Add Drop-off Schedule</span>
            </button>
        </div>

        <mat-table #dropoffTable [dataSource]="dropoffDataSource" matSort
            style="max-height: 500px; overflow: auto; margin-top: 10px;">
            <ng-container [matColumnDef]="'display'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Size Type</mat-header-cell>
                <mat-cell *matCellDef="let data; let i = index" class="fs-12 ">
                    <mat-chip class="primary-chip sleek-chip">{{ isObject(data?.requirement?.container_size_type) ?
                        data?.requirement?.container_size_type.display + ' (' +
                        data?.requirement?.condition?.value + ')' : data?.requirement }}</mat-chip>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'display_name'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Off-Hire Location</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <span class="displayName">
                        {{ isObject(data?.port) ? data?.port.display_name : data?.port }}
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'per_month_permitted_quantity'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>PMQ</mat-header-cell>
                <mat-cell *matCellDef="let data; let i = index" class="fs-12">
                    <app-number-field [isEditable]="data.isDEdit" class="w-100i" [class.editable]="data.isPEdit"
                        [required]="false" [(ngModel)]="data.per_month_permitted_quantity"
                        [(errors)]="data.error.per_month_permitted_quantity" [minValue]="0" [noDecimal]="true">
                    </app-number-field>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'total_permitted_quantity'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>TPQ</mat-header-cell>
                <mat-cell *matCellDef="let data; let i = index" class="fs-12">
                    <app-number-field [isEditable]="data.isDEdit" class="w-100i" [class.editable]="data.isPEdit"
                        [ngStyle]="{'color': data.error.total_permitted_quantity.length != 0 ? 'red' : ''}"
                        [required]="false" [(ngModel)]="data.total_permitted_quantity"
                        [matTooltip]="data.error.total_permitted_quantity" [matTooltipClass]="'tooltip-error'"
                        [(errors)]="data.error.total_permitted_quantity" [minValue]="0" [noDecimal]="true">
                    </app-number-field>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'handling_charge'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Handling-In Charges</mat-header-cell>
                <mat-cell *matCellDef="let data; let i = index" class="fs-12">
                    <app-number-field [isEditable]="data.isDEdit" class="w-100i" [class.editable]="data.isPEdit"
                        [required]="false" [numVal]="data.handling_charge_currency" [(ngModel)]="data.handling_charge"
                        [(errors)]="data.error.handling_charge" [minValue]="0">
                    </app-number-field>
                    <!-- {{ ' ' + data.handling_charge_currency}} -->
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'dropoff_charge'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Drop-off Charges</mat-header-cell>
                <mat-cell *matCellDef="let data; let i = index" class="fs-12">
                    <app-number-field [isEditable]="data.isDEdit" class="w-100i" [class.editable]="data.isPEdit"
                        [required]="false" [numVal]="data.dropoff_charge_currency" [(ngModel)]="data.dropoff_charge"
                        [(errors)]="data.error.dropoff_charge" [minValue]="0">
                    </app-number-field>
                    <!-- {{ ' ' + data.dropoff_charge_currency}} -->
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'remarks'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Remarks</mat-header-cell>
                <mat-cell *matCellDef="let data; let i = index" class="fs-12">
                    <app-text-field [isMultiline]="true" [isEditable]="data.isDEdit" fxLayout="column" class="w-100i"
                        [class.editable]="data.isPEdit" [(ngModel)]="data.remarks">
                    </app-text-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                <mat-cell *matCellDef="let data;let i = index">
                    <div class="actionButtons">
                        <!-- <button mat-icon-button class="save-button" > -->
                        <!-- <mat-icon>check_circle</mat-icon> -->
                        <i class="flaticon-tick" matTooltip="Save Changes" matTooltipPosition="left"
                            *ngIf="data.isDEdit" color="primary" (click)="saveDropoffEdit(data)"></i>
                        <!-- </button> -->
                        <!-- <button mat-icon-button class="save-button" > -->
                        <!-- <mat-icon>edit</mat-icon> -->
                        <i class="flaticon-pencil" *ngIf="!data.isDEdit" matTooltip="Edit" matTooltipPosition="left"
                            color="primary" (click)="editDropoff(data)"></i>
                        <!-- </button> -->
                        <!-- <button mat-icon-button class="delete-button" > -->
                        <i class="flaticon-delete" matTooltip="Delete" matTooltipPosition="right" color="warn"
                            (click)="deleteDropoff(i)"></i>
                        <!-- </button> -->
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row class="header-row" *matHeaderRowDef="dropoffDisplayColumns sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: dropoffDisplayColumns; let index"
                [style.background-color]="row.has_errors ? '#ff000047' : 'white'"
                [style.color]="row.has_errors ? 'white' : 'black'" [class.blur]="loading"
                [hidden]="row.hideRow == null ? false : row.hideRow != row.requirement?.container_size_type?.display">
            </mat-row>
        </mat-table>
        <div class="loadingData" [class.d-none]="!loading">
            <logzy-gear-loader></logzy-gear-loader>
        </div>
    </div>
</div>